<template>
  <div class="sys-main-warpper">
    <div class="brands-wrapper">
      <LeftBrandList :dataList="brandsList" :activeIndex="activeIndex" @clickSide="clickSide"></LeftBrandList>
    </div>
    <div class="framework-container">
      <CommonSearch :custom="custom" :txtWidth="'120px'" @reset="clickResetBtn" @commonSearch-Click="clickSearchBtn">
      </CommonSearch>
      <framework-table ref="frameworkTable" :tableData="tableData" @clickAddIcon="clickAddIcon"
        @clickEditIcon="clickEditIcon" @clickTdDelete="clickTdDelete"
        :currentBrandId="currentBrandId"></framework-table>
    </div>
    <AddModal ref="addModalRef" @closeAddModal="_getBrandTree"></AddModal>
    <ActionPwdModal ref="actionPwdRef" @actionSave="_deleteData"></ActionPwdModal>
  </div>
</template>

<script>
import AddModal from "./components/addModal.vue";
import LeftBrandList from "@/components/leftBrandList.vue";
import ActionPwdModal from '@/components/actionPwdModal.vue'
import CommonSearch from "@/base/searchCommon.vue";
import FrameworkTable from './components/frameworkTable.vue'
import Cookies from "js-cookie";
export default {
  components: {
    CommonSearch,
    FrameworkTable,
    AddModal,
    ActionPwdModal,
    LeftBrandList
  },
  data() {
    return {
      currentBrandId: null,
      activeIndex: 0,
      addObj: {},
      tableData: [],
      realBrandIdsArr: [],
      realOutletIdsArr: [],
      brandsList: [],
      monitorId: Number(Cookies.get("monitorId")),
      custom: [
        {
          name: vm.$t('client.site.regionClient') + "：",
          activeCode: "",
          type: "input",
        },
      ]
    }
  },
  mounted() {
    this._getBrandsList();
  },
  methods: {
    clickResetBtn() { },
    clickSearchBtn() {
      this._getBrandTree();
    },
    _getBrandTree() {
      this.$Http.get(this.$Api.areaBrandTree + '/' + this.monitorId + '/' + this.currentBrandId + '?name=' + this.custom[0].activeCode).then(res => {
        if (res.success) {
          if (res.result) {
            this.tableData = res.result;
          }
        }
      })
    },
    clickSide(item, index, dataList) {
      this.activeIndex = index;
      this.currentBrandId = dataList[this.activeIndex].id;
      this.custom[0].activeCode = '';
      this._getBrandTree();
    },
    async _getBrandsList() {
      let res = await this.$Http.get(this.$Api.brandCurrentBrandList + '/' + this.monitorId);
      if (res.success && res.result.length > 0) {
        this.brandsList = res.result;
        let { brandId } = this.$route.query;
        if (brandId) {
          res.result.forEach((item, index) => {
            if (item.id === brandId) {
              this.activeIndex = index
            }
          });
          setTimeout(() => {
            let currentDOM = document.getElementsByClassName('active')[0];
            currentDOM.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
          }, 1000);
        }
        this.currentBrandId = this.brandsList[this.activeIndex].id;
        this._getBrandTree();
      }
    },

    clickEditIcon(scope) {
      this.$refs.addModalRef.open(1, scope, this.currentBrandId);
    },

    clickAddIcon(scope) {
      this.$refs.addModalRef.open(0, scope, this.currentBrandId);
    },

    clickTdDelete(scope) {
      this.realOutletIdsArr = [];
      this.realBrandIdsArr = [];
      if (scope.row.type === "outlet") {
        this.realOutletIdsArr = [Number(scope.row.id.substr(scope.row.id.indexOf("_") + 1))]
      } else if (scope.row.type === "brand") {
        this.realBrandIdsArr = [Number(scope.row.id.substr(scope.row.id.indexOf("_") + 1))]
      }
      this._checkDeleteInfo();
    },

    async _checkDeleteInfo() {
      let params = {
        deleteBrandIds: this.realBrandIdsArr,
        deleteOutletIds: this.realOutletIdsArr,
      };
      let res = await this.$Http.post(this.$Api.areaCheckDeleteBrandAndOutlet + '/' + this.monitorId, params);
      if (res.result) {
        this.$message.error(res.result);
      } else {
        this.$refs.actionPwdRef.open();
      }
    },
    async _deleteData(password) {
      let params = {
        deleteBrandIds: this.realBrandIdsArr,
        deleteOutletIds: this.realOutletIdsArr,
        password
      };
      let res = await this.$Http.post(this.$Api.areaDeleteBrandAndOutlet + '/' + this.monitorId + '/' + this.currentBrandId, params);
      if (res.success) {
        this.$refs.actionPwdRef.close();
        this.$message.success(vm.$t('common.successful'));
        this._getBrandTree();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/common/scss/button.scss";

$theme-color: #2077ff;
$btn-opacity: 0.8;

.sys-main-warpper {
  display: flex;
  width: 100%;

  .brands-wrapper {
    margin-right: 30px;
    flex: 0 0 245px;
    width: 245px;
    flex-shrink: 0;
  }

  .framework-container {
    display: flex;
    flex-direction: column;
    width: calc(100% - 245px - 30px);
    // height: 830px;
    .framework-content {
      // height: 738px;
      .top-box {
        padding-left: 16px;
        margin-bottom: 16px;
        box-sizing: border-box;

        .fold-btn {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.sys-main-warpper {
  .search-box {
    margin-bottom: 8px;

    @media screen and (max-width: 1440px) {
      .commonSearchWrapper .screenCon:nth-child(3) {
        margin-right: 35px;
      }
    }

  }

}

.sys-main-warpper .is-scrolling-none .el-table__empty-block {
  min-height: 350px;
  background: url("../../../assets/icon/no-data.svg") center no-repeat;
}

.sys-main-warpper .is-scrolling-none .el-table__empty-block .el-table__empty-text {
  height: 450px;
  color: transparent;
}

.content-table .el-table .el-table--border td {
  border-right: none;
}

.content-table .el-table--enable-row-transition .el-table__body td {
  border-right: none;
}

.content-table .el-table-column--selection label.is-disabled {
  visibility: hidden;
}

.el-table__expand-icon .el-icon-arrow-right {
  background: url("../../../assets/icon/icon-pack-up.svg") no-repeat;
}

.el-table__expand-icon .el-icon-arrow-right:before {
  visibility: hidden;
}

.cell .el-table__expand-icon--expanded {
  transform: rotate(180deg);
}

.el-table__expand-icon--expanded .el-icon-arrow-right {
  background: url("../../../assets/icon/icon-expand.svg") no-repeat;
}

.el-table__expand-icon--expanded .el-icon-arrow-right:before {
  visibility: hidden;
}
</style>
